import { Box, Text } from '@usap/uicomponents'
import styled from 'styled-components'

export const SubtotalContainer = styled(Box)`
  position: relative;
  flex-direction: row;
  justify-content: space-between;
`

export const SubtotalText = styled(Text)`
  color: #282832;
`

export const SubtotalLeftSide = styled('span')`
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 0 0; 
`
